module.exports = __webpack_public_path__ + "img/51626529_S.bdca4bd3.png";